import { useTranslation } from "react-i18next";
import {
  Box as MuiBox,
  Paper as MuiPaper,
  Typography as MuiTypography,
  List as MuiList,
  ListItem as MuiListItem,
} from "@mui/material";

import noStudyAssociatedErrorPageStyle from "./NoStudyAssociatedErrorPageStyle";
import Mail from "app/shared/UI/Mail";

const NoStudyAssociatedErrorPageContent = (props) => {
  const { t } = useTranslation();
  return (
    <MuiBox sx={noStudyAssociatedErrorPageStyle.rootBox}>
      <MuiPaper variant="outlined" sx={noStudyAssociatedErrorPageStyle.firstPaper}>
        <MuiTypography variant="subtitle1" fontWeight="bold" gutterBottom>
          {t(`NoStudyAssociation.NoStudyAssociationTitle`)}
        </MuiTypography>
        <MuiTypography>
          {t(`NoStudyAssociation.NoStudyAssociationInfo`)}
        </MuiTypography>
      </MuiPaper>

      <MuiPaper variant="outlined" sx={noStudyAssociatedErrorPageStyle.secondPaper}>
        <MuiTypography variant="subtitle1" fontWeight="bold" gutterBottom>
          {t(`NoStudyAssociation.NoStudyAssociationErrorExplanationHeading`)}
        </MuiTypography>
        <MuiTypography paragraph>
          {t(`NoStudyAssociation.NoStudyAssociationErrorExplanation`)}
        </MuiTypography>

        <MuiTypography variant="subtitle1" fontWeight="bold" gutterBottom>
          {t(`NoStudyAssociation.NextSteps`)}
        </MuiTypography>
        <MuiTypography paragraph>
          {t(`NoStudyAssociation.NextStepsInfo`)}
        </MuiTypography>

        <MuiList dense>
          <MuiListItem disablePadding>
            <MuiTypography variant="subtitle1">
              {t(`NoStudyAssociation.emailText`)}
              <Mail emailAddress={t(`NoStudyAssociation.emailAddress`)}>
                {t(`NoStudyAssociation.emailAddress`)}
              </Mail>
            </MuiTypography>
          </MuiListItem>
          <MuiListItem disablePadding>
            <MuiTypography variant="subtitle1">
              {t(`NoStudyAssociation.phoneText`)}
              {t(`NoStudyAssociation.phoneNumber`)}
            </MuiTypography>
          </MuiListItem>
        </MuiList>

        <MuiTypography paragraph> {t(`NoStudyAssociation.AccessStep`)} </MuiTypography>

        <MuiTypography paragraph>{t(`NoStudyAssociation.ThankYouMessage`)}</MuiTypography>

        <MuiTypography> {t(`NoStudyAssociation.StanfordOrgName`)} </MuiTypography>
      </MuiPaper>
    </MuiBox>
  );
};

export default NoStudyAssociatedErrorPageContent;
